module.exports = __webpack_public_path__ + "static/media/1.303a9800.jpg";